import { useFormContext } from 'react-hook-form';
import '../css/calculation.css';
import ErrorMessage from './services/error-message';
import { downloadPDF, printPDF } from './services/pdfGenerator';

function collectErrors(errors, parentPath = '') {
    const result = [];
    Object.entries(errors).forEach(([key, value]) => {
        const path = parentPath ? `${parentPath}.${key}` : key;
        if (!value) return;
        // это конечная ошибка поля
        if ('type' in value) {
            result.push({
                path,
                error: value,
            });
            return;
        }
        // вложенный объект → рекурсия
        result.push(...collectErrors(value, path));
    });

    return result;
}

export default function Calculation({ result, allFields, allShapes, usdData }) {
    const {
        formState: { errors },
    } = useFormContext();
    const allErrors = collectErrors(errors);

    const handleDownload = async () => {
        try {
            await downloadPDF(allFields, allShapes, result);
        } catch (error) {
            alert('Ошибка при создании PDF для загрузки: ' + error.message);
        }
    };

    const handlePrint = async () => {
        try {
            await printPDF(allFields, allShapes, result);
        } catch (error) {
            alert('Ошибка при создании PDF для печати: ' + error.message);
        }
    };

    return (
        <>
            <div className="step-title">
                <h2 className="num-step-title">6</h2>
                <h2>Расчет:</h2>
            </div>
            <div className="counter-grid">
                <div>
                    <label htmlFor="answer-hrn">Стоимость </label>
                    <input
                        id="answer-hrn"
                        type="text"
                        name="count-answer"
                        className="result-input"
                        value={
                            typeof result !== 'object' && result !== null && result !== ''
                                ? (result * (usdData[0].rate * 1.002)).toLocaleString('ru-RU', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                  })
                                : ''
                        }
                        readOnly
                    />{' '}
                    грн
                </div>
                <div>
                    <label htmlFor="answer-dol">Стоимость </label>
                    <input
                        id="answer-dol"
                        type="text"
                        name="count-answer"
                        className="result-input"
                        value={
                            typeof result !== 'object' && result !== null
                                ? result.toLocaleString('ru-RU', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                  })
                                : ''
                        }
                        readOnly
                    />{' '}
                    дол
                </div>
                <button type="submit">РАСЧИТАТЬ</button>
                <div className="pdf-buttons">
                    <button onClick={handleDownload} disabled={typeof result === 'object' || result === ''}>
                        Скачать
                    </button>
                    <button onClick={handlePrint} disabled={typeof result === 'object' || result === ''}>
                        Распечатать
                    </button>
                </div>
                {typeof result === 'object' ? <ErrorMessage error={result} /> : undefined}
                {allErrors.map(({ path, error }) => (
                    <div key={path}>
                        <ErrorMessage error={error} />
                    </div>
                ))}
            </div>
        </>
    );
}
